import { AxiosError } from 'axios';
import { Dispatch, SetStateAction, createContext, useContext } from 'react';
import { UseMutateFunction } from 'react-query';
import { LoginUser, LoginUserResponse } from './api/login';

export interface AuthContext {
  login: UseMutateFunction<LoginUserResponse, AxiosError, LoginUser>;
  logout: () => void;
  isAuthLoading: boolean;
  loginError?: string;
  isAuthenticated: boolean;
  setIsAuthenticated: Dispatch<SetStateAction<boolean>>;
}

const authContext = createContext<AuthContext>({
  login: () => null,
  logout: () => null,
  isAuthenticated: false,
  isAuthLoading: false,
  setIsAuthenticated: () => {},
});

export const useAuthContext = () => useContext(authContext);

export default authContext;
